import { Navigate, Outlet } from "react-router";
import { useUserProfileContext } from "@context/user_profile";
import {
    mayEnterReceptionist,
    isReceptionistProd,
    isReceptionistEnabled,
} from "@receptionist/role";

/**
 * Gate for the /receptionist/* product routes, mirroring OuraRoute.
 *
 * 1. Is the product launched here at all? It is off in production until the
 *    backend contract lands, and that is checked before the profile resolves so
 *    an unlaunched product cannot be probed by its loading behaviour.
 * 2. Is this session allowed in? Production is authoritative, and the answer is
 *    the two receptionist roles plus platform admins — the same set the API
 *    admits (ourteam-backend#4670). In dev/staging the backend does not emit
 *    receptionist roles yet, so any authenticated user may preview,
 *    impersonating a role via the in-app dev switch.
 *
 * Authentication itself is enforced by the enclosing ProtectedRoute.
 */
export default function ReceptionistRoute() {
    const [isLoadingUserProfile, userInfo] = useUserProfileContext();
    if (!isReceptionistEnabled()) return <Navigate to="/unauthorized" />;
    if (isLoadingUserProfile) return <></>;
    if (isReceptionistProd() && userInfo && !mayEnterReceptionist(userInfo.role)) {
        return <Navigate to="/unauthorized" />;
    }
    return <Outlet />;
}
